<div class="detail-page-card">
    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        @if (systemModel) {
            <form>
                <div class="row">
                    <div class="col-6">
                        @if (systemModel.hidden) {
                            <div class="name">{{ 'dataStructures.noSystem' | t }}</div>
                        } @else {
                            <div>
                                @if (!disabled) {
                                    <button
                                        type="button"
                                        class="btn btn-raised red pull-right"
                                        (click)="deleteSystem()"
                                    >
                                        <i class="fas fa-minus-circle"></i>
                                    </button>
                                }
                                <div class="name">
                                    {{ systemModel.name }}
                                </div>
                            </div>
                        }
                    </div>
                    <div class="col-6">
                        <div class="btn-toolbar">
                            @if (!disabled) {
                                <button type="button" class="btn btn-raised pull-right" (click)="manageData()">
                                    <i class="fas fa-plus-circle"></i>
                                    <span>{{ 'dataStructures.manageDataBtn' | t }}</span>
                                </button>
                            }
                        </div>
                    </div>
                </div>
                <hr />
                @if (systemModel.dataSubjectsLoaded) {
                    <datasubjects-overview
                        [dataSubjects]="systemModel.dataSubjects"
                        [disabled]="disabled"
                    >
                    </datasubjects-overview>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </form>
        }
    </div>
</div>
